export const CExpandableFaqsFragments = {
  field: `
    fragment expandableFaqs on expandableFaqs_MatrixField {
      ... on expandableFaqs_block_Entry {
        idName
        heading
        faqs {
          title
          id
          ... on faq_faq_Entry {
            copy: faqAnswer
          }
          ... on safetyInformation_Entry {
            copy: safetyInformationCopy
          }
        }
      }
    }
  `,
  faqEntry: `
    fragment expandableFaqsFaqEntry on faq_faq_Entry {
      title
      id
      copy: faqAnswer
    }
  `,
}
